var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.928223 0.928223L13.0721 13.0721","stroke":"#35312E","stroke-width":"1.875"}}),_vm._v(" "),_c('path',{attrs:{"d":"M13.0721 0.928223L0.928223 13.0721","stroke":"#35312E","stroke-width":"1.875"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }